import {Field, Form, Formik} from 'formik'
import React, {useState} from 'react'
import {useIntl} from 'react-intl'
import {useAuth} from '../../../auth'
import {createSettings} from '../../core/_requests'
import {toast} from 'react-toastify'
import {SettingsInputPeriod} from '../../../widgets/components/Input/SettingsInputPeriod'
import * as Yup from 'yup'
import Skeleton from 'react-loading-skeleton'
import {archivalSettingsOptions} from '../../core/_constants'

const Archival = ({aiEmailData, aiEmailLoading, fetchAiEmailDataWithoutLoader}: any) => {
  const {formatMessage} = useIntl()
  const {companyId} = useAuth()
  const [loading, setLoading] = useState<boolean>(false)


  

  const initialValues = {
    isDeleteArchive: aiEmailData?.archive || false,
    isDeleteWarning: aiEmailData?.warnBeforeDeletion || false,
    deleteArchiveYear: archivalSettingsOptions.find(({value}) => value === aiEmailData?.deleteArchiveAfterPeriod)?.value || '',
    deleteArchivePeriod: aiEmailData?.deleteArchiveAfterValue || '',
  }

  const validationSchema = Yup.object().shape({
    deleteArchivePeriod: Yup.number()
      .required('Default Retention Period is required')
      .nullable()
      .min(1, "Delete Archive After cann't be negative or 0"),
  })

  const handleSubmit = async (values: any, {resetForm}: any) => {
    if (!companyId) return
    setLoading(true)
    const payload = {
      archive: values?.isDeleteArchive,
      warnBeforeDeletion: values?.isDeleteWarning,
      deleteArchiveAfterValue: parseInt(values?.deleteArchivePeriod),
      deleteArchiveAfterPeriod: values?.deleteArchiveYear,
    }
    try {
      const {
        data: {success, errors},
      } = await createSettings(companyId, payload)
      if (success) {
        toast.success('Setting saved successfully')
        fetchAiEmailDataWithoutLoader()
      } else {
        toast.error(errors[0])
      }
    } catch (err) {
    } finally {
      setLoading(false)
    }
  }


  return (
    <div>
      <>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
          enableReinitialize
          validateOnChange
          validateOnMount
        >
          {(formik) => {

            return (
              <Form>
                <div className='row'>
                  <p className='fw-semibold m-0'>{formatMessage({id: 'Documents Archival'})}</p>
                </div>
                <div className='col-md-12 col-12 border-bottom py-2'>
                  <div className='form-check form-check-custom form-check-solid form-check-primary form-switch'>
                    <label className='togglebtn mx-0'>
                      <Field
                        className='togglebtn__input'
                        name='isDeleteArchive'
                        type='checkbox'
                        disabled={aiEmailLoading}
                        formik={formik}
                        onChange={(e: any) => {
                          formik.handleChange(e)
                        }}
                      />
                      <div className='togglebtn__fill'></div>
                    </label>
                    <div className='d-flex flex-column justify-content-end mt-2'>
                      <div className='d-flex'>
                        <div>
                          <label
                            className='form-check-label fw-semibold font-size-13 title-notification'
                            data-bs-toggle='tooltip'
                          >
                            {formatMessage({id: 'Delete or Archive?'})}
                          </label>
                        </div>
                      </div>
                      <label
                        className='form-check-label text-clr58 fw-normal fs-7'
                        data-bs-toggle='tooltip'
                      >
                        {formatMessage({
                          id: 'Turn this “On” If you want to rather Delete the documents once their retention period is over. Keep this switch “Off” to Archive records.',
                        })}
                      </label>
                    </div>
                  </div>
                </div>
                <div className='col-md-12 col-12 border-bottom py-2'>
                  <div className='form-check form-check-custom form-check-solid form-check-primary form-switch'>
                    <label className='togglebtn mx-0'>
                      <Field
                        className='togglebtn__input'
                        name='isDeleteWarning'
                        type='checkbox'
                        disabled={aiEmailLoading}
                        formik={formik}
                      />
                      <div className='togglebtn__fill'></div>
                    </label>
                    <div className='d-flex flex-column justify-content-end mt-2'>
                      <div className='d-flex'>
                        <div>
                          <label
                            className='form-check-label fw-semibold font-size-13 title-notification'
                            data-bs-toggle='tooltip'
                          >
                            {formatMessage({id: 'Warn Before Deletion'})}
                          </label>
                        </div>
                      </div>
                      <label
                        className='form-check-label text-clr58 fw-normal fs-7'
                        data-bs-toggle='tooltip'
                      >
                        {formatMessage({
                          id: 'Turn this “On” to notify admin 30 days before automatic deletion occurs',
                        })}
                      </label>
                    </div>
                  </div>
                </div>
                <div className='col-md-6 col-12 mt-5'>
                  {aiEmailLoading ? (
                    <div className='d-flex flex-row my-3'>
                      <div className='w-25 me-5'>
                        <Skeleton
                          height={30}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                      <div className='w-75'>
                        <Skeleton
                          height={30}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                    </div>
                  ) : (
                    <SettingsInputPeriod
                      label={formatMessage({id: 'Delete Archives After'})}
                      toolTipText={formatMessage({
                        id: `Select the number of years after which archived files will be permanently deleted or flushed from the RecordsKeeper system.`,
                      })}
                      fieldName='deleteArchivePeriod'
                      placeholder={''}
                      placeholderSelect={''}
                      formik={formik}
                      isTooltipForModal={true}
                      options={archivalSettingsOptions}
                      selectOptionFieldName='deleteArchiveYear'
                    />
                  )}
                </div>
                <div className='d-flex justify-content-end'>
                  <button
                    type='submit'
                    className='btn bg-primary text-white custom-button-property border border-1 mb-md-4 mb-0 px-6 py-4 text-center w-100 w-md-auto order-1 order-md-2'
                    disabled={!formik.isValid || loading}
                  >
                    {!loading && (
                      <span className='indicator-label font-size-13 p-0'>
                        {formatMessage({id: 'Save Changes'})}
                      </span>
                    )}
                    {loading && (
                      <span className='indicator-label font-size-13 p-0'>
                        {formatMessage({id: 'Please wait...'})}
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </button>
                </div>
              </Form>
            )
          }}
        </Formik>
      </>
    </div>
  )
}

export default Archival
